<!--分数评定 Score-->
<template>
  <div class="question-container" style="border: 1px solid #ededed">
    <div class="question-type">分数评定</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>
    <div v-for="(item, index) in list" :key="index" class="evaluate-view">
      <div class="evaluate-view-score">
        <p class="sub-title">
          {{ item.text }}：<span class="sub-title">
            {{ isEmpty(item.context) ? "0" : item.context }}分
          </span>
        </p>
      </div>
      <div class="evaluate-view-container">
        <div
          v-for="(subItem, subIndex) in dataObj.scoreNum"
          :key="subIndex"
          class="evaluate-item"
          :style="
            String(item.context) === String(dataObj.minScore + subIndex)
              ? activeStyle
              : inactiveStyle
          "
          @click="handleEvaluate(item, index, subItem, subIndex)"
        >
          {{ dataObj.minScore + subIndex }}
        </div>
      </div>
      <div v-if="!ifElseConfig" class="rating">
        <div class="rating-item">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="item.ratingArr[0]"
            :disabled="true"
          />
        </div>
        <div class="rating-item">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="item.ratingArr[1]"
            :disabled="true"
          />
        </div>
        <div class="rating-item">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="item.ratingArr[2]"
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div v-if="ifElseConfig" class="rating">
      <div class="rating-item">
        <input
          placeholder-class="input-placeholder"
          type="text"
          placeholder="编辑提示词"
          v-model="value1"
          :disabled="true"
        />
      </div>
      <div class="rating-item">
        <input
          placeholder-class="input-placeholder"
          type="text"
          placeholder="编辑提示词"
          v-model="value2"
          :disabled="true"
        />
      </div>
      <div class="rating-item">
        <input
          placeholder-class="input-placeholder"
          type="text"
          placeholder="编辑提示词"
          v-model="value3"
          :disabled="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    operate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: {},
      answerObj: {},
      index: 0,
      list: [],
      count: 3,
      isMultiple: true,
      images: [],
      rules: [],
      value1: "",
      value2: "",
      value3: "",
      minScore: 0,
      scoreNum: 0,
      ifElseConfig: false,
      themeColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      activeStyle: {
        background: "rgba(58, 96, 255, 1)",
        border: "1px solid rgba(58, 96, 255, 1)",
        color: "#ffffff",
      },
      inactiveStyle: {
        background: "#FFFFFF",
        border: "none",
        color: "#2B2F36",
      },
    };
  },
  methods: {
    isEmpty(str) {
      return str === "" || str === null || str === undefined;
    },
    handleEvaluate(item, index, subItem, subIndex) {
      this.list[index].context = `${this.dataObj.minScore + subIndex}`;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list,
      });
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          answer: {
            question_id: this.dataObj.id,
            type: this.dataObj.type,
            if_hide: this.dataObj.if_hide,
            answer: this.list.map((item) => {
              return {
                id: item.id,
                context: item.context,
              };
            }),
          },
          index: this.index,
        }),
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;

        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.list = JSON.parse(newVal.data.chooseList).list;

        this.minScore = newVal.data.minScore;
        this.scoreNum = newVal.data.scoreNum;

        if (
          newVal.data.elseConfig !== "" &&
          newVal.data.elseConfig !== undefined &&
          newVal.data.elseConfig !== null
        ) {
          this.ifElseConfig = true;
          var cfg = JSON.parse(newVal.data.elseConfig);
          this.value1 = cfg[0] || "";
          this.value2 = cfg[1] || "";
          this.value3 = cfg[2] || "";
        } else {
          this.ifElseConfig = false;
        }

        if (this.operate !== "answer") {
          if (
            newVal.answer &&
            newVal.answer.answer &&
            newVal.answer.answer.length > 0
          ) {
            var ansArr = newVal.answer.answer;

            ansArr.forEach((ans, i) => {
              if (this.list[i]) {
                this.$set(this.list[i], "context", ans.context);
              }
            });
          } else {
            this.list.forEach((item) => {
              this.$set(item, "context", 0);
            });
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.score-view {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}

.score-view-item-active {
  width: 29px;
  height: 30px;
  line-height: 30px;
  background-color: #4a73f8;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.score-view-item-inactive {
  width: 27px;
  height: 27px;
  line-height: 27px;
  border: 1px solid #dcdde0;
  background-color: #f9f9f9;
  color: #2b2f36;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

.evaluate-view {
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 25px;
}

.evaluate-view-score {
  width: 100%;
  text-align: left;
}

.evaluate-view-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  gap: 10px;
}

.evaluate-item {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border-radius: 25px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.rating {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.rating-item {
  width: 170px;
  height: 33px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  box-sizing: border-box;
}

.rating-item input {
  width: 100%;
  height: 100%;
  border: none;
  box-sizing: border-box;
  font-size: 13px;
  text-align: center;
}

.sub-title .sub-title {
  color: rgba(58, 96, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationPreview/EvaluationPreviewScore.vue